import { styled } from 'ui/styles'
import { QuestionnaireFormRow } from '../atoms/form-row'
import { Text } from 'ui/components'
import { RadioGroup } from '../atoms/radio-group'
import { breakpoints } from 'shared/dimensions'
import { PlatformTestingReturn } from '../hooks/usePlatformTesting'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const RadioGroupWrapper = styled.div`
  width: 50%;

  @media (max-width: ${breakpoints.tablet - 1}px) {
    width: 100%;
  }
`

export const PlatformTestingSection: React.FC<PlatformTestingReturn> = ({
  radioButtons,
  radioButtonsKeys,
  textAreas,
  textAreasKeys,
  onRadioChange
}) => (
  <Wrapper>
    {textAreasKeys.map((key) => (
      <QuestionnaireFormRow key={key} label={textAreas[key].label} input={textAreas[key].input!} />
    ))}
    <RadioGroupWrapper>
      <Text variant="h7">С тестированием каких продуктов приходилось работать?</Text>
      {radioButtonsKeys.map((key, i) => (
        <RadioGroup key={key} label={radioButtons[key].label} onChange={onRadioChange} isAlwaysInRow />
      ))}
    </RadioGroupWrapper>
  </Wrapper>
)
